import appVersion from './appVersion';
import autoDigest from './autoDigest';
import customIframe from './customIframe';
import diagramEditor from './diagramEditor';
import diagramView from './diagramView';
import disableAnimation from './disableAnimation';
import draggable from './draggable';
import dropTarget from './dropTarget';
import findings from './findings';
import iframeOnload from './iframeOnload';
import onImageError from './onImageError';
import iframeWrapper from './iframeWrapper';
import txtWrapper from "./txtWrapper";
import isSwiped from './isSwiped';
import onEnter from './onEnter';
import reverse from './reverse';
import scrollTop from './scrollTop';
import simplePopover from './simplePopover';
import swipeOnClick from './swipeOnClick';
import tooltipDir from './tooltip.dir';
import tooltip from './tooltip';
import dropdown from './dropdown';
import dropdownMenu from './dropdownMenu';
import dropdownMenuOld from './dropdownMenu-old';
import dateInput from './dateInput';
import numberInputValidate from './numberInputValidate';
import textarea from './textareaScroll';
import numbersOnly from './numbersOnly';
import networkStatusChecker from './networkStatusChecker';
import resolveFollowUp from './resolve-follow-up';
import followUpPatientDetails from './follow-up-patient-details';
import noNewLine from './no-new-line';
import inputDropdown from './inputDropdown';
import angularCropper from './angularCropper';



// WEBPACK FOOTER //
// ./src/scripts/directives/index.js